export default "__VITE_ASSET__BVFTHpCJ__"